export default "__VITE_ASSET__B5H2XH4q__"